export default __webpack_public_path__ + "static/media/all_users.204f8686.svg";